import { TextFieldHelper } from "@goodgamestudios/core";
import { ErrorCodes } from "../../constants/shared/ErrorCodes";
import { Poker2BanditEvent } from "../../event/Poker2BanditEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";
import { Poker2NoMoneyDialogProperties } from "./Poker2NoMoneyDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2NoMoneyDialog extends Poker2Dialog {
    public static NAME: string = "Poker2NoMoneyDialog";
    private static SCALE_FACTOR: number = 4;

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        var copytext: string = "";

        while (this.noMoneyDialog.mc_holder.numChildren > 0)
            this.noMoneyDialog.mc_holder.removeChildAt(0);

        if (this.noMoneyDialogProperties.currencyType == 10) {
            var chips: Library.PokerInterface.Icon_Chips = new Library.PokerInterface.Icon_Chips();
            chips.scaleX = chips.scaleY = Poker2NoMoneyDialog.SCALE_FACTOR;
            this.noMoneyDialog.mc_holder.addChild(chips);
        }
        else {
            var gold: Library.PokerInterface.IconGold = new Library.PokerInterface.IconGold();
            gold.scaleX = gold.scaleY = Poker2NoMoneyDialog.SCALE_FACTOR;
            this.noMoneyDialog.mc_holder.addChild(gold);
        }

        if (Poker2Model.userData.isGuest()) {
            this.noMoneyDialog.btn_moreGold.label = Poker2Model.languageData.getTextById("generic_login_register");
            copytext = Poker2Model.languageData.getTextById("alert_nomoney_guest_copy");
        }
        else {
            this.noMoneyDialog.btn_moreGold.label = Poker2Model.languageData.getTextById("dialog_nomoney_btn_moregold");
            copytext = this.noMoneyDialogProperties.copy;
        }

        this.noMoneyDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_goback");

        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.noMoneyDialog.txt_title, this.noMoneyDialogProperties.title);
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.noMoneyDialog.txt_copy, copytext, 3);

        this.noMoneyDialog.btn_moreGold.visible = this.env.usePayment;
    }

    protected onClick(event: MouseEvent): void {
        if (event.target instanceof BasicButton && !event.target.enabled) return;
        super.onClick(event);
        switch (event.target) {
            case this.noMoneyDialog.btn_ok:
                this.hide();
                break;
            case this.noMoneyDialog.btn_moreGold:
                if (Poker2Model.userData.isGuest())
                    this.controller.onStartRegisterDialog();
                else
                    this.controller.onClickMoreMoney(null);
                this.hide();
                break;
        }
    }
    public show(): void {
        super.show();
        this.noMoneyDialog.btn_moreGold.selected();
    }
    public hide(): void {
        this.controller.dispatchEvent(new Poker2BanditEvent("hidePoker2NoMoneyDialog"));
        super.hide();
    }
    protected get noMoneyDialogProperties(): Poker2NoMoneyDialogProperties {
        return this.properties as Poker2NoMoneyDialogProperties;
    }

    protected get noMoneyDialog(): Library.PokerInterface.PokerNoMoney {
        return this.disp as Library.PokerInterface.PokerNoMoney;
    }
}

import { BasicButton } from "@goodgamestudios/poker2-createjs-assets";
